import { Resource } from "../resource";

export class  TopHeaderBanner extends Resource {
    text: string;
    link: string;
    content: string
}
